/**
 * Where the settlement record begins, in words.
 *
 * Settlement outcomes were stored with no time on them at all until migration
 * 0010, which is FIND-31: "when did this settlement fail" had no answer, for
 * any settlement, by any means, on the money path. The column is nullable and
 * stays nullable, because rows written before it genuinely do not know.
 *
 * So a chart of settlements is empty to the left of that moment, and an empty
 * stretch reads as a period in which nothing was settled. That is false, and it
 * is false in the reassuring direction, which is the shape of defect this
 * programme keeps paying for. The page says where its knowledge starts instead.
 */

export function settlementReading(total: number, recordedFrom: string | null): string {
  if (recordedFrom === null) {
    return 'No settlement has been recorded with a time yet. Settlements before that carry no time at all, so they are in the journal and on no chart: this is not a period in which nothing was settled.'
  }
  const since = new Date(recordedFrom).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'Europe/Berlin',
  })
  const counted = total === 0
    ? 'No settlement was recorded in this range'
    : `${total} settlement${total === 1 ? '' : 's'} recorded in this range`
  return `${counted}. Settlements have carried a time only since ${since}; earlier ones are in the journal and appear on no chart, so anything to the left of that is missing rather than empty.`
}
